export const topicTable = {
    "prefix": "brewcore/v1/<id>/",
    "topics": [
        {
            "name": "status",
            "dir": "machine_to_cloud",
            "qos": 1,
            "retain": true,
            "schema": "status",
            "maxBytes": 512,
            "de": "Geburt, Last Will, Abschied vor Neustart"
        },
        {
            "name": "profile",
            "dir": "machine_to_cloud",
            "qos": 1,
            "retain": true,
            "schema": "profile",
            "maxBytes": 1536,
            "de": "Ausstattungsprofil mit Prüfsumme der Befehlsliste"
        },
        {
            "name": "state/<group>",
            "dir": "machine_to_cloud",
            "qos": 1,
            "retain": true,
            "maxBytes": 2048,
            "de": "Zustandsgruppe, Schema laut catalog/state-groups.json"
        },
        {
            "name": "live",
            "dir": "machine_to_cloud",
            "qos": 0,
            "retain": false,
            "schema": "live",
            "maxBytes": 768,
            "de": "Live-Werte etwa 1 Hz, nur mit gültigem watch"
        },
        {
            "name": "event",
            "dir": "machine_to_cloud",
            "qos": 1,
            "retain": false,
            "schema": "event",
            "maxBytes": 1024,
            "de": "Ereignis, Quittung über sync"
        },
        {
            "name": "shot",
            "dir": "machine_to_cloud",
            "qos": 1,
            "retain": false,
            "schema": "shot",
            "maxBytes": 2048,
            "de": "Bezug mit Kurve (ggf. in Teilen), Quittung über sync"
        },
        {
            "name": "ack",
            "dir": "machine_to_cloud",
            "qos": 1,
            "retain": false,
            "schema": "ack",
            "maxBytes": 1024,
            "de": "Rückmeldung zu einem Befehl"
        },
        {
            "name": "xfer",
            "dir": "machine_to_cloud",
            "qos": 1,
            "retain": false,
            "schema": "xfer",
            "maxBytes": 1536,
            "de": "Stück einer großen Antwort (Diagnose, Katalog, Verlauf)"
        },
        {
            "name": "fw/req",
            "dir": "machine_to_cloud",
            "qos": 1,
            "retain": false,
            "schema": "fw-req",
            "maxBytes": 256,
            "de": "Anforderung des nächsten Stücks beim Firmware-Update"
        },
        {
            "name": "cmd",
            "dir": "cloud_to_machine",
            "qos": 1,
            "retain": false,
            "schema": "cmd",
            "maxBytes": 2048,
            "de": "Befehl (set oder action), nie festgehalten"
        },
        {
            "name": "sync",
            "dir": "cloud_to_machine",
            "qos": 1,
            "retain": false,
            "schema": "sync",
            "maxBytes": 1024,
            "de": "Empfangsquittungen für Bezüge, Ereignisse und selbst gestartete Übertragungen"
        },
        {
            "name": "time",
            "dir": "cloud_to_machine",
            "qos": 1,
            "retain": false,
            "schema": "time",
            "maxBytes": 128,
            "de": "Cloud-Zeit direkt nach jeder Geburt; einzige Zeitquelle außer NTP"
        },
        {
            "name": "watch",
            "dir": "cloud_to_machine",
            "qos": 1,
            "retain": true,
            "schema": "watch",
            "maxBytes": 128,
            "de": "Zuschauer-Signal (Lease 60 s)"
        },
        {
            "name": "fw/data",
            "dir": "cloud_to_machine",
            "qos": 1,
            "retain": false,
            "binary": true,
            "maxBytes": 16404,
            "de": "Binärer Rahmen mit einem Stück des Firmware-Abbilds"
        }
    ]
};
export const stateGroupCatalog = {
    "groups": [
        {
            "id": "recipe",
            "schema": "state-params",
            "store": "fs",
            "label": {
                "de": "Rezept",
                "en": "Recipe"
            },
            "cadence": "bei Änderung (entprellt 0,5–1 s) und beim Verbinden",
            "owner": "Maschine",
            "fields": {
                "values": "Parameter der Gruppe recipe (Befehlsliste): Temperatur, Dosis, Mahlgrad, Bohne, Stopp-Art, Ziele, Pre-Infusion"
            }
        },
        {
            "id": "presets",
            "schema": "state-params",
            "store": "fs",
            "label": {
                "de": "Schnellwahl",
                "en": "Presets"
            },
            "cadence": "bei Änderung und beim Verbinden",
            "owner": "Maschine",
            "fields": {
                "values": "brew.presets (Format presets, siehe README)"
            }
        },
        {
            "id": "machine",
            "schema": "state-params",
            "store": "fs",
            "label": {
                "de": "Maschine",
                "en": "Machine"
            },
            "cadence": "bei Änderung und beim Verbinden",
            "owner": "Maschine",
            "fields": {
                "values": "Heizen, PID, Offset, Heizen beim Bezug, Display, Sensoren",
                "pending": "Werte, die erst nach einem Neustart wirken"
            }
        },
        {
            "id": "maintenance",
            "schema": "state-params",
            "store": "fs",
            "label": {
                "de": "Pflege-Einstellungen",
                "en": "Care settings"
            },
            "cadence": "bei Änderung und beim Verbinden",
            "owner": "Maschine",
            "fields": {
                "values": "Erinnerungsgrenzen (Backflush, Entkalken, Tropfschale) und Backflush-Ablauf"
            }
        },
        {
            "id": "schedule",
            "schema": "state-params",
            "store": "fs",
            "label": {
                "de": "Zeitplan und Standby",
                "en": "Schedule and standby"
            },
            "cadence": "bei Änderung und beim Verbinden",
            "owner": "Maschine",
            "fields": {
                "values": "Standby, Warmhalten, Aufwärm-Spülen, Wochenplan, Urlaub"
            }
        },
        {
            "id": "system",
            "schema": "state-params",
            "store": "fs",
            "label": {
                "de": "System",
                "en": "System"
            },
            "cadence": "bei Änderung und beim Verbinden",
            "owner": "Maschine",
            "fields": {
                "values": "Gerätename, Protokoll-Level (nie Passwörter)"
            }
        },
        {
            "id": "scale",
            "schema": "state-scale",
            "store": "fs",
            "label": {
                "de": "Waage",
                "en": "Scale"
            },
            "cadence": "bei Änderung (Verbindung, Akku in 5-%-Schritten, Suche) und beim Verbinden",
            "owner": "Maschine",
            "fields": {
                "status": "off, none, disconnected, connected",
                "selected": "gewählte Waage",
                "battery": "Akku %",
                "searching": "Suche läuft",
                "found": "Ergebnis der letzten Suche"
            }
        },
        {
            "id": "beans",
            "schema": "state-beans",
            "store": "nvs",
            "label": {
                "de": "Bohnen",
                "en": "Beans"
            },
            "cadence": "bei Änderung und beim Verbinden",
            "owner": "Maschine (Cloud spiegelt und führt den Namensverlauf)",
            "fields": {
                "current": "ID der aktuellen Bohne",
                "items": "Bohnenprofile, zuletzt benutzt zuerst"
            }
        },
        {
            "id": "care",
            "schema": "state-care",
            "store": "nvs",
            "label": {
                "de": "Pflege-Zähler",
                "en": "Care counters"
            },
            "cadence": "nach jedem Bezug und jeder Pflege-Aktion (entprellt) und beim Verbinden",
            "owner": "Maschine (bleibt beim Entkoppeln)",
            "fields": {
                "today": "Bezüge heute",
                "week": "Bezüge diese Woche",
                "total": "Bezüge gesamt",
                "coffeeGrams": "Kaffee gesamt",
                "waterMl": "Wasser seit Entkalken",
                "descaledAt": "letztes Entkalken",
                "backflushAt": "letzter Backflush",
                "shotsSinceBackflush": "Bezüge seit Backflush",
                "dripMl": "Tropfschale",
                "due": "fällig: descale, backflush, drip"
            }
        },
        {
            "id": "ref",
            "schema": "state-ref",
            "store": "nvs",
            "label": {
                "de": "Referenz-Bezug",
                "en": "Reference shot"
            },
            "cadence": "bei Änderung und beim Verbinden",
            "owner": "Cloud entscheidet, Maschine hält den gesendeten",
            "fields": {
                "shot": "Schlüssel des Referenz-Bezugs oder null"
            }
        },
        {
            "id": "op",
            "schema": "state-op",
            "store": "ram",
            "label": {
                "de": "Betrieb",
                "en": "Operation"
            },
            "cadence": "bei Änderung (entprellt 0,5–1 s), auch ohne Zuschauer, und beim Verbinden",
            "owner": "Maschine",
            "fields": {
                "state": "Maschinenzustand",
                "brew": "Bezug läuft, Quelle",
                "standby": "Countdown, Warmhalten",
                "backflush": "Modus, Fortschritt",
                "warmup": "Aufwärm-Spülen",
                "descale": "Entkalk-Programm",
                "announce": "Ankündigung am Display"
            }
        },
        {
            "id": "boot",
            "schema": "state-boot",
            "store": "ram",
            "label": {
                "de": "Letzter Start",
                "en": "Last start"
            },
            "cadence": "einmal je Start (beim ersten Verbinden), bei Bestätigung der Firmware",
            "owner": "Maschine",
            "fields": {
                "cause": "Startgrund",
                "reset": "Roh-Startgrund",
                "crash": "Absturz-Kurzfassung",
                "fw": "Version",
                "fwState": "pending/confirmed",
                "resumed": "Betriebszustand nach dem Start"
            }
        },
        {
            "id": "update",
            "schema": "state-update",
            "store": "ram",
            "label": {
                "de": "Firmware-Update",
                "en": "Firmware update"
            },
            "cadence": "bei Phasenwechsel, Fortschritt höchstens alle 5 s, beim Verbinden",
            "owner": "Maschine",
            "fields": {
                "phase": "Phase",
                "tag": "Update-Versuch",
                "offset": "geschriebene Bytes",
                "size": "Abbildgröße",
                "reason": "Grund bei failed/rolled_back"
            }
        },
        {
            "id": "health",
            "schema": "state-health",
            "store": "ram",
            "label": {
                "de": "Diagnose",
                "en": "Diagnostics"
            },
            "cadence": "beim Verbinden und alle 10–15 min",
            "owner": "Maschine",
            "fields": {
                "rssi": "WLAN",
                "heapFree": "freier Heap",
                "heapMin": "Tiefstwert",
                "heapBlock": "größter Block",
                "reconnects": "Verbindungsversuche",
                "eventsDropped": "verworfene Ereignisse",
                "shotsDropped": "überschriebene Bezüge",
                "nvsFree": "freie NVS-Einträge"
            }
        }
    ]
};
export const reasonCatalog = {
    "reasons": [
        {
            "code": "unknown_command",
            "origin": "both",
            "de": "Maschine kennt diesen Befehl nicht.",
            "en": "Machine doesn't know this command."
        },
        {
            "code": "unknown_param",
            "origin": "both",
            "de": "Maschine kennt diese Einstellung nicht.",
            "en": "Machine doesn't know this setting."
        },
        {
            "code": "invalid_value",
            "origin": "both",
            "de": "Dieser Wert ist nicht erlaubt.",
            "en": "This value isn't allowed."
        },
        {
            "code": "too_long",
            "origin": "both",
            "de": "Text ist zu lang.",
            "en": "Text is too long."
        },
        {
            "code": "read_only",
            "origin": "both",
            "de": "Dieser Wert lässt sich nicht ändern.",
            "en": "This value can't be changed."
        },
        {
            "code": "not_applicable",
            "origin": "machine",
            "de": "Hängt von einer anderen Einstellung ab.",
            "en": "Depends on another setting."
        },
        {
            "code": "malformed",
            "origin": "both",
            "de": "Anfrage war nicht lesbar.",
            "en": "Request couldn't be read.",
            "http": 400
        },
        {
            "code": "too_large",
            "origin": "both",
            "de": "Anfrage ist zu groß.",
            "en": "Request is too large.",
            "http": 413
        },
        {
            "code": "busy_brew",
            "origin": "machine",
            "de": "Ein Bezug läuft.",
            "en": "A shot is running."
        },
        {
            "code": "busy_water",
            "origin": "machine",
            "de": "Maschine spült gerade.",
            "en": "Machine is flushing."
        },
        {
            "code": "busy_program",
            "origin": "machine",
            "de": "Ein Pflegeprogramm läuft.",
            "en": "A care programme is running."
        },
        {
            "code": "busy_update",
            "origin": "machine",
            "de": "Ein Firmware-Update läuft.",
            "en": "A firmware update is running."
        },
        {
            "code": "not_ready",
            "origin": "machine",
            "de": "Maschine ist noch nicht bereit.",
            "en": "Machine isn't ready yet."
        },
        {
            "code": "fault",
            "origin": "machine",
            "de": "Maschine meldet Übertemperatur oder Sensorfehler.",
            "en": "Machine reports overheating or a sensor fault."
        },
        {
            "code": "switch_on",
            "origin": "machine",
            "de": "Bezugsschalter ist eingeschaltet. Bitte zuerst ausschalten.",
            "en": "Brew switch is on. Please turn it off first."
        },
        {
            "code": "no_watertank_sensor",
            "origin": "machine",
            "de": "Nur mit eingeschaltetem Füllstandssensor möglich.",
            "en": "Only possible with the level sensor on."
        },
        {
            "code": "tank_empty",
            "origin": "machine",
            "de": "Wassertank ist leer. Bitte auffüllen.",
            "en": "Water tank is empty. Please refill."
        },
        {
            "code": "drip_not_counted",
            "origin": "machine",
            "de": "Fassungsvermögen der Tropfschale fehlt. Bitte zuerst eintragen.",
            "en": "Drip tray capacity is missing. Please enter it first."
        },
        {
            "code": "drip_full",
            "origin": "machine",
            "de": "Tropfschale ist voll. Bitte zuerst leeren.",
            "en": "Drip tray is full. Please empty it first."
        },
        {
            "code": "stop_mode_manual",
            "origin": "machine",
            "de": "Stopp von Hand ist eingestellt. Bitte Zeit oder Gewicht wählen.",
            "en": "Stop by hand is set. Please choose time or weight."
        },
        {
            "code": "scale_disabled",
            "origin": "machine",
            "de": "Waage ist in den Einstellungen aus. Bitte dort einschalten.",
            "en": "Scale is off in Settings. Please turn it on there."
        },
        {
            "code": "scale_not_connected",
            "origin": "machine",
            "de": "Waage ist nicht verbunden. Bitte einschalten.",
            "en": "Scale isn't connected. Please turn it on."
        },
        {
            "code": "no_clock",
            "origin": "machine",
            "de": "Maschine hat noch keine Uhrzeit. Bitte gleich noch einmal versuchen.",
            "en": "Machine doesn't know the time yet. Please try again in a moment."
        },
        {
            "code": "standby_not_allowed",
            "origin": "machine",
            "de": "Standby ist nur möglich, wenn nichts läuft.",
            "en": "Standby is only possible when nothing is running."
        },
        {
            "code": "not_in_standby",
            "origin": "machine",
            "de": "Maschine ist nicht im Standby.",
            "en": "Machine isn't in standby."
        },
        {
            "code": "not_found",
            "origin": "machine",
            "de": "Dieser Eintrag fehlt auf der Maschine.",
            "en": "This entry isn't on the machine."
        },
        {
            "code": "bean_in_use",
            "origin": "machine",
            "de": "Diese Bohne ist gewählt. Bitte zuerst eine andere wählen.",
            "en": "This bean is selected. Please choose another one first."
        },
        {
            "code": "storage_full",
            "origin": "machine",
            "de": "Speicher der Maschine ist voll.",
            "en": "Machine storage is full."
        },
        {
            "code": "limit",
            "origin": "both",
            "de": "Limit ist erreicht. Bitte später noch einmal versuchen.",
            "en": "Limit has been reached. Please try again later.",
            "http": 429
        },
        {
            "code": "low_memory",
            "origin": "machine",
            "de": "Maschine ist ausgelastet. Bitte gleich noch einmal versuchen.",
            "en": "Machine is under heavy load. Please try again in a moment."
        },
        {
            "code": "wrong_type",
            "origin": "machine",
            "de": "Diese Firmware ist nicht für diese Maschine.",
            "en": "This firmware isn't for this machine."
        },
        {
            "code": "signature_invalid",
            "origin": "machine",
            "de": "Firmware-Signatur ist ungültig.",
            "en": "Firmware signature isn't valid."
        },
        {
            "code": "hash_mismatch",
            "origin": "machine",
            "de": "Firmware kam beschädigt an. Bitte gleich noch einmal versuchen.",
            "en": "Firmware arrived damaged. Please try again in a moment."
        },
        {
            "code": "downgrade",
            "origin": "machine",
            "de": "Diese Firmware ist älter als die installierte.",
            "en": "This firmware is older than the installed one."
        },
        {
            "code": "parts_incomplete",
            "origin": "machine",
            "de": "Nicht alles kam bei der Maschine an. Bitte gleich noch einmal versuchen.",
            "en": "Not everything reached the machine. Please try again in a moment."
        },
        {
            "code": "internal",
            "origin": "machine",
            "de": "Etwas ist schiefgelaufen. Bitte gleich noch einmal versuchen.",
            "en": "Something went wrong. Please try again in a moment."
        },
        {
            "code": "offline",
            "origin": "cloud",
            "de": "Maschine ist gerade nicht erreichbar.",
            "en": "Machine can't be reached right now.",
            "http": 409
        },
        {
            "code": "forbidden",
            "origin": "cloud",
            "de": "Dafür fehlt die Berechtigung.",
            "en": "This isn't permitted.",
            "http": 403
        },
        {
            "code": "owner_only",
            "origin": "cloud",
            "de": "Das kann nur der Besitzer.",
            "en": "Only the owner can do this.",
            "http": 403
        },
        {
            "code": "fresh_login",
            "origin": "cloud",
            "de": "Bitte dafür neu anmelden.",
            "en": "Please sign in again to do this.",
            "http": 401
        },
        {
            "code": "confirm_required",
            "origin": "cloud",
            "de": "Bitte zuerst bestätigen.",
            "en": "Please confirm first.",
            "http": 400
        },
        {
            "code": "pending",
            "origin": "cloud",
            "de": "Ein Befehl dieser Art ist schon unterwegs.",
            "en": "A command like this is already pending.",
            "http": 409
        },
        {
            "code": "no_response",
            "origin": "cloud",
            "de": "Maschine hat nicht geantwortet.",
            "en": "Machine didn't respond."
        },
        {
            "code": "remote_disabled",
            "origin": "cloud",
            "de": "Fernsteuerung ist gesperrt. Bitte später noch einmal versuchen.",
            "en": "Remote control is locked. Please try again later.",
            "http": 423
        },
        {
            "code": "app_outdated",
            "origin": "cloud",
            "de": "App ist veraltet. Bitte neu laden.",
            "en": "App is out of date. Please reload.",
            "http": 426
        },
        {
            "code": "pairing_expired",
            "origin": "cloud",
            "de": "Kopplungscode ist abgelaufen. Bitte aktuellen Code vom Display eingeben.",
            "en": "Pairing code has expired. Please enter the new one from the display.",
            "http": 410
        },
        {
            "code": "pairing_taken",
            "origin": "cloud",
            "de": "Maschine ist schon gekoppelt.",
            "en": "Machine is already paired.",
            "http": 409
        },
        {
            "code": "pairing_invalid",
            "origin": "cloud",
            "de": "Kopplungscode stimmt nicht. Bitte am Display prüfen.",
            "en": "Pairing code isn't right. Please check it on the display.",
            "http": 404
        },
        {
            "code": "pairing_link_refused",
            "origin": "cloud",
            "de": "Alte Maschine war eben noch online. Bitte später noch einmal versuchen.",
            "en": "Previous machine was online until recently. Please try again later.",
            "http": 409
        }
    ]
};
export const eventCatalog = {
    "events": [
        {
            "type": "ready",
            "severity": "info",
            "de": "Bereit",
            "en": "Ready"
        },
        {
            "type": "tank_empty",
            "severity": "warn",
            "de": "Wassertank leer",
            "en": "Water tank empty"
        },
        {
            "type": "tank_ok",
            "severity": "info",
            "de": "Wassertank wieder gefüllt",
            "en": "Water tank refilled"
        },
        {
            "type": "overtemp",
            "severity": "alarm",
            "de": "Übertemperatur, Heizung aus",
            "en": "Overheating, heater off",
            "data": {
                "temp": "gemessene Temperatur (°C)"
            }
        },
        {
            "type": "sensor_error",
            "severity": "alarm",
            "de": "Temperatursensor gestört, Heizung aus",
            "en": "Temperature sensor fault, heater off",
            "data": {
                "value": "Rohwert"
            }
        },
        {
            "type": "backflush_due",
            "severity": "info",
            "de": "Backflush fällig",
            "en": "Backflush due",
            "data": {
                "shots": "Bezüge seit dem letzten Backflush"
            }
        },
        {
            "type": "descale_due",
            "severity": "info",
            "de": "Entkalken fällig",
            "en": "Descaling due",
            "data": {
                "litres": "Liter seit dem Entkalken"
            }
        },
        {
            "type": "drip_full",
            "severity": "warn",
            "de": "Tropfschale voll",
            "en": "Drip tray full",
            "data": {
                "ml": "geschätzte Menge"
            }
        },
        {
            "type": "program_done",
            "severity": "info",
            "de": "Programm beendet",
            "en": "Programme finished",
            "data": {
                "program": "flush, warmup_flush, backflush, cleaning, descale",
                "aborted": "true, wenn abgebrochen"
            }
        },
        {
            "type": "descale_waiting",
            "severity": "warn",
            "de": "Entkalken wartet auf „Weiter“",
            "en": "Descaling waiting for “Next”",
            "data": {
                "phase": "Phase (3 nachfüllen, 5 Klarwasser)"
            }
        },
        {
            "type": "switch_still_on",
            "severity": "warn",
            "de": "Bezugsschalter noch an",
            "en": "Brew switch still on"
        },
        {
            "type": "please_flush",
            "severity": "info",
            "de": "Spülen fällig",
            "en": "Flush due"
        },
        {
            "type": "scale_battery_low",
            "severity": "info",
            "de": "Akku der Waage schwach",
            "en": "Scale battery low",
            "data": {
                "battery": "Akku in %"
            }
        },
        {
            "type": "backflush_armed",
            "severity": "info",
            "de": "Backflush bereit",
            "en": "Backflush ready",
            "data": {
                "cleaner": "true bei Reinigung mit Reiniger",
                "by": "Name aus dem Befehl, falls aus der Ferne"
            }
        },
        {
            "type": "care_reset",
            "severity": "info",
            "de": "Pflege-Zähler zurückgesetzt",
            "en": "Care counter reset",
            "data": {
                "counter": "descale oder drip"
            }
        },
        {
            "type": "protected_changed",
            "severity": "warn",
            "de": "Geschützte Einstellung geändert",
            "en": "Protected setting changed",
            "data": {
                "param": "Parameter-ID",
                "value": "neuer Wert",
                "source": "cloud, display, settings",
                "cmd": "Befehls-ID, falls aus der Cloud"
            }
        },
        {
            "type": "standby_entered",
            "severity": "info",
            "de": "Standby gestartet",
            "en": "Standby started",
            "data": {
                "cause": "schedule, user, switch, timer, remote"
            }
        },
        {
            "type": "woken",
            "severity": "info",
            "de": "Aufgeweckt",
            "en": "Woken up",
            "data": {
                "cause": "schedule, user, switch, remote, power"
            }
        },
        {
            "type": "restart",
            "severity": "info",
            "de": "Neu gestartet",
            "en": "Restarted",
            "data": {
                "cause": "wie state/boot cause",
                "crash": "Kurzfassung des Absturzes oder fehlt"
            }
        },
        {
            "type": "update_ok",
            "severity": "info",
            "de": "Firmware aktualisiert",
            "en": "Firmware updated",
            "data": {
                "from": "vorige Version",
                "to": "neue Version"
            }
        },
        {
            "type": "update_rollback",
            "severity": "warn",
            "de": "Update fehlgeschlagen, vorige Firmware läuft",
            "en": "Update failed, previous firmware running",
            "data": {
                "from": "fehlgeschlagene Version",
                "to": "laufende Version"
            }
        },
        {
            "type": "warmup_flush_pending",
            "severity": "info",
            "de": "Aufwärm-Spülen steht an",
            "en": "Warm-up flush pending"
        },
        {
            "type": "remote_announced",
            "severity": "info",
            "de": "Aktion aus der Ferne angekündigt",
            "en": "Remote action announced",
            "data": {
                "action": "Aktionsname",
                "by": "Name",
                "cmd": "Befehls-ID"
            }
        },
        {
            "type": "data_generation",
            "severity": "warn",
            "de": "Speicher neu angelegt",
            "en": "Storage set up from scratch",
            "data": {
                "store": "nvs, fs",
                "id": "neue Datengeneration",
                "origin": "initial, reset, lost"
            }
        },
        {
            "type": "events_dropped",
            "severity": "warn",
            "de": "Ereignisse verloren",
            "en": "Events lost",
            "data": {
                "count": "Anzahl"
            }
        },
        {
            "type": "shots_dropped",
            "severity": "warn",
            "de": "Bezüge vor dem Hochladen überschrieben",
            "en": "Shots overwritten before upload",
            "data": {
                "count": "Anzahl"
            }
        },
        {
            "type": "coupling_ended",
            "severity": "info",
            "de": "An der Maschine entkoppelt",
            "en": "Unpaired at the machine",
            "data": {
                "cause": "factory_reset, sale_reset"
            }
        },
        {
            "type": "delivery_dead_letter",
            "severity": "warn",
            "de": "Daten von der Cloud abgelehnt",
            "en": "Data rejected by the cloud",
            "data": {
                "kind": "shot, event",
                "e": "Epoche",
                "n": "Nummer",
                "r": "conflict, rejected",
                "reason": "Grund-Code bei rejected"
            }
        }
    ]
};
export const machineStateCatalog = {
    "states": [
        {
            "code": 0,
            "key": "init",
            "de": "Startet",
            "en": "Starting"
        },
        {
            "code": 10,
            "key": "normal",
            "de": "In Betrieb",
            "en": "On"
        },
        {
            "code": 20,
            "key": "brew",
            "de": "Bezug läuft",
            "en": "Brewing"
        },
        {
            "code": 25,
            "key": "flush",
            "de": "Spült",
            "en": "Flushing"
        },
        {
            "code": 30,
            "key": "steam",
            "de": "Dampf",
            "en": "Steam"
        },
        {
            "code": 40,
            "key": "hot_water",
            "de": "Heißwasser",
            "en": "Hot water"
        },
        {
            "code": 50,
            "key": "backflush",
            "de": "Backflush",
            "en": "Backflush"
        },
        {
            "code": 60,
            "key": "pid_off",
            "de": "Heizung aus",
            "en": "Heater off"
        },
        {
            "code": 70,
            "key": "tank_empty",
            "de": "Wassertank leer",
            "en": "Water tank empty"
        },
        {
            "code": 80,
            "key": "standby",
            "de": "Standby",
            "en": "Standby"
        },
        {
            "code": 100,
            "key": "overtemp",
            "de": "Übertemperatur",
            "en": "Overheating",
            "fault": true
        },
        {
            "code": 110,
            "key": "sensor_error",
            "de": "Sensorfehler",
            "en": "Sensor fault",
            "fault": true
        }
    ]
};
/** Command list of the Orione (generated from the firmware, docs/protocol/v1/tools/gen_orione_commands.py). */
export const orioneCommandCatalog = {
    "machineType": "orione",
    "proto": "1.0",
    "checksum": "sha256:7bcd685bdaba2a9fc091c6fe628be1860d8e1532b5d81439733c1229c8cd32c6",
    "generated": {
        "by": "docs/protocol/v1/tools/gen_orione_commands.py",
        "from": [
            "docs/protocol/v1/tools/orione-overlay.json",
            "firmware/lib/Orione/src/OrioneCare.h",
            "firmware/lib/Orione/src/OrioneFixed.h",
            "firmware/src/Config.h",
            "firmware/src/ParameterRegistry.cpp",
            "firmware/src/defaults.h"
        ],
        "note": "Nicht von Hand ändern: Overlay oder Firmware ändern und neu erzeugen."
    },
    "actionClasses": [
        {
            "class": "setting",
            "ttl": 30,
            "clock": false,
            "autoRepeat": true,
            "rank": 0,
            "de": "Einstellung oder Datensatz: Zielwert, doppelt harmlos; gilt 30 s, geht auch ohne Uhr",
            "en": "Setting or record: target value, harmless twice; valid 30 s, works without a clock"
        },
        {
            "class": "diag",
            "ttl": 30,
            "clock": false,
            "autoRepeat": true,
            "rank": 1,
            "de": "Nur lesen (Diagnose, Katalog, Verlauf); gilt 30 s, geht auch ohne Uhr",
            "en": "Read only (diagnosis, catalog, history); valid 30 s, works without a clock"
        },
        {
            "class": "stop",
            "ttl": 10,
            "clock": false,
            "autoRepeat": false,
            "rank": 2,
            "de": "Stoppen, abbrechen, entschärfen: muss immer gehen, auch ohne Uhr; gilt 10 s, damit es keinen späteren Ablauf trifft",
            "en": "Stop, abort, disarm: must always work, also without a clock; valid 10 s so it never hits a later run"
        },
        {
            "class": "device_admin",
            "ttl": 30,
            "clock": true,
            "autoRepeat": false,
            "rank": 3,
            "de": "Geräteverwaltung (Neustart, Resets, Entkoppeln, Update): gilt 30 s, nur mit gültiger Uhr, nie automatisch wiederholt",
            "en": "Device administration (restart, resets, unpair, update): valid 30 s, only with a valid clock, never repeated automatically"
        },
        {
            "class": "water_heat_wake",
            "ttl": 10,
            "clock": true,
            "autoRepeat": false,
            "rank": 4,
            "de": "Bewegt Wasser, heizt oder weckt ohne Person an der Maschine, auch Einstellungen, die so etwas scharf schalten: gilt 10 s, nur mit gültiger Uhr, nie automatisch wiederholt",
            "en": "Moves water, heats or wakes without anybody at the machine, also settings that arm such a mode: valid 10 s, only with a valid clock, never repeated automatically"
        }
    ],
    "preconditions": [
        {
            "code": "not_busy",
            "reasons": [
                "busy_brew",
                "busy_water",
                "busy_program",
                "busy_update"
            ],
            "de": "Kein Bezug, kein Spülen, kein Programm, kein Update (machineBusy())",
            "en": "No shot, flush, programme or update running (machineBusy())"
        },
        {
            "code": "no_fault",
            "reasons": [
                "fault"
            ],
            "de": "Keine Übertemperatur, kein Sensorfehler",
            "en": "No overtemperature, no sensor error"
        },
        {
            "code": "ready",
            "reasons": [
                "not_ready"
            ],
            "de": "Betriebszustand „Bereit“",
            "en": "Operating state 'ready'"
        },
        {
            "code": "switch_off",
            "reasons": [
                "switch_on"
            ],
            "de": "Bezugsschalter S3 steht auf AUS",
            "en": "Brew switch S3 is off"
        },
        {
            "code": "watertank_sensor",
            "reasons": [
                "no_watertank_sensor"
            ],
            "de": "Wasserstandssensor vorhanden und aktiv",
            "en": "Water level sensor present and active"
        },
        {
            "code": "tank_ok",
            "reasons": [
                "tank_empty"
            ],
            "de": "Tank nicht leer",
            "en": "Tank not empty"
        },
        {
            "code": "drip_counted",
            "reasons": [
                "drip_not_counted"
            ],
            "de": "Tropfschale wird gezählt (Kapazität > 0)",
            "en": "Drip tray is counted (capacity > 0)"
        },
        {
            "code": "drip_not_full",
            "reasons": [
                "drip_full"
            ],
            "de": "Tropfschale nicht als voll gemeldet",
            "en": "Drip tray not reported full"
        },
        {
            "code": "stop_auto",
            "reasons": [
                "stop_mode_manual"
            ],
            "de": "Stopp nach Zeit oder Gewicht",
            "en": "Stop by time or weight"
        },
        {
            "code": "scale_enabled",
            "reasons": [
                "scale_disabled"
            ],
            "de": "Bluetooth-Waage eingeschaltet",
            "en": "Bluetooth scale switched on"
        },
        {
            "code": "scale_connected",
            "reasons": [
                "scale_not_connected"
            ],
            "de": "Waage verbunden",
            "en": "Scale connected"
        },
        {
            "code": "not_brewing",
            "reasons": [
                "busy_brew"
            ],
            "de": "Kein Bezug läuft",
            "en": "No shot running"
        },
        {
            "code": "clock_valid",
            "reasons": [
                "no_clock"
            ],
            "de": "Gültige Uhr (NTP oder Versatz aus dem Thema time); verlangt von den Aktionsklassen water_heat_wake und device_admin, nicht in pre aufgeführt",
            "en": "Valid clock (NTP or offset from the time topic); required by the action classes water_heat_wake and device_admin, not listed in pre"
        },
        {
            "code": "standby_allowed",
            "reasons": [
                "standby_not_allowed"
            ],
            "de": "Zustand Bereit (10), Heizung aus (60) oder Tank leer (70), kein Bezug",
            "en": "State ready (10), heater off (60) or tank empty (70), no shot"
        },
        {
            "code": "in_standby",
            "reasons": [
                "not_in_standby"
            ],
            "de": "Maschine im Standby (80)",
            "en": "Machine in standby (80)"
        },
        {
            "code": "idle_or_standby",
            "reasons": [
                "busy_brew",
                "busy_water",
                "busy_program",
                "not_ready"
            ],
            "de": "Standby oder Leerlauf, nichts läuft",
            "en": "Standby or idle, nothing running"
        },
        {
            "code": "record_on_machine",
            "reasons": [
                "not_found"
            ],
            "de": "Datensatz liegt noch auf der Maschine",
            "en": "Record is still on the machine"
        },
        {
            "code": "bean_not_current",
            "reasons": [
                "bean_in_use"
            ],
            "de": "Nicht die aktuelle Bohne",
            "en": "Not the current bean"
        },
        {
            "code": "heap_ok",
            "reasons": [
                "low_memory"
            ],
            "de": "Genug freier Speicher",
            "en": "Enough free memory"
        },
        {
            "code": "type_match",
            "reasons": [
                "wrong_type",
                "signature_invalid",
                "downgrade"
            ],
            "de": "Signiertes Abbild passt zu Typ, Hardware-Stand und Build-Art",
            "en": "Signed image matches type, hardware revision and build kind"
        }
    ],
    "limits": [
        {
            "class": "brew_app",
            "max": 6,
            "per": "hour",
            "de": "Höchstens 6 Bezüge aus der App je Stunde (E-1, NFR-20)",
            "en": "At most 6 shots from the app per hour"
        },
        {
            "class": "water_remote",
            "max": 6,
            "per": "hour",
            "de": "Höchstens 6 Starts von Wasseraktionen aus der Ferne je Stunde (FR-23, NFR-20)",
            "en": "At most 6 remote water action starts per hour"
        },
        {
            "class": "restart",
            "max": 3,
            "per": "hour",
            "de": "Höchstens 3 Fern-Neustarts je Stunde (FR-24)",
            "en": "At most 3 remote restarts per hour"
        },
        {
            "class": "wifi_reset",
            "max": 1,
            "per": "day",
            "de": "WLAN-Reset höchstens einmal am Tag (FR-24)",
            "en": "WLAN reset at most once a day"
        },
        {
            "class": "factory_reset",
            "max": 1,
            "per": "day",
            "de": "Werkseinstellungen höchstens einmal am Tag (FR-24)",
            "en": "Factory reset at most once a day"
        },
        {
            "class": "update",
            "max": 2,
            "per": "day",
            "de": "Höchstens 2 Firmware-Updates am Tag (FR-35)",
            "en": "At most 2 firmware updates a day"
        }
    ],
    "fixed": [
        {
            "id": "hardware.relays.heater.trigger_type",
            "value": 1,
            "de": "fest in Config::get() (OrioneFixed.h)",
            "en": "fixed in Config::get() (OrioneFixed.h)"
        },
        {
            "id": "hardware.relays.valve.trigger_type",
            "value": 1,
            "de": "fest in Config::get() (OrioneFixed.h)",
            "en": "fixed in Config::get() (OrioneFixed.h)"
        },
        {
            "id": "hardware.relays.pump.trigger_type",
            "value": 1,
            "de": "fest in Config::get() (OrioneFixed.h)",
            "en": "fixed in Config::get() (OrioneFixed.h)"
        },
        {
            "id": "hardware.switches.brew.enabled",
            "value": 1,
            "de": "fest in Config::get() (OrioneFixed.h)",
            "en": "fixed in Config::get() (OrioneFixed.h)"
        },
        {
            "id": "hardware.switches.brew.type",
            "value": 1,
            "de": "fest in Config::get() (OrioneFixed.h)",
            "en": "fixed in Config::get() (OrioneFixed.h)"
        },
        {
            "id": "hardware.switches.brew.mode",
            "value": 0,
            "de": "fest in Config::get() (OrioneFixed.h)",
            "en": "fixed in Config::get() (OrioneFixed.h)"
        },
        {
            "id": "hardware.sensors.scale.type",
            "value": 2,
            "de": "fest in Config::get() (OrioneFixed.h)",
            "en": "fixed in Config::get() (OrioneFixed.h)"
        },
        {
            "id": "system.offline_mode",
            "value": 0,
            "de": "fest in Config::get() (OrioneFixed.h)",
            "en": "fixed in Config::get() (OrioneFixed.h)"
        },
        {
            "id": "emergency_stop_temp",
            "value": 145,
            "de": "Not-Aus-Grenze 145 °C (fest in der Firmware)",
            "en": "Emergency stop at 145 °C (fixed in the firmware)"
        },
        {
            "id": "brew_max_duration",
            "value": "max(60 s, Ziel + PI + 10 s); nach Gewicht 60 s",
            "de": "Höchstdauer eines Bezugs (FR-25)",
            "en": "Longest shot (FR-25)"
        },
        {
            "id": "system.auth",
            "value": false,
            "de": "Anmeldung der lokalen App fest aus (Orione-Build)",
            "en": "Local app login fixed off (Orione build)"
        }
    ],
    "excluded": [
        {
            "id": "TARE_ON",
            "reason": "Laufzeit-Umschalter; aus der Ferne als Aktion scale.tare (Zielzustand, Tara im Bezug gesperrt)",
            "replacedBy": "scale.tare"
        },
        {
            "id": "BACKFLUSH_ON",
            "reason": "Laufzeit-Umschalter; aus der Ferne als Aktion backflush.set mit Zielzustand",
            "replacedBy": "backflush.set"
        },
        {
            "id": "VERSION",
            "reason": "nur lesbar; steht in profile.fw"
        },
        {
            "id": "system.ota_password",
            "reason": "Geheimnis; nur in der Build-Art dev, nie in der Cloud-App und nie in state (FR-24, FR-7)"
        },
        {
            "id": "schedule.days",
            "reason": "alter Zeitplan, beim ersten Start in schedule.plan übernommen"
        },
        {
            "id": "schedule.on",
            "reason": "alter Zeitplan, beim ersten Start in schedule.plan übernommen"
        },
        {
            "id": "schedule.off",
            "reason": "alter Zeitplan, beim ersten Start in schedule.plan übernommen"
        },
        {
            "id": "hardware.sensors.scale.address",
            "reason": "wird über scale.select/scale.forget gesetzt, steht in state/scale",
            "replacedBy": "scale.select"
        },
        {
            "id": "hardware.sensors.scale.name",
            "reason": "wird über scale.select/scale.forget gesetzt, steht in state/scale",
            "replacedBy": "scale.select"
        }
    ],
    "cloudOperations": [
        {
            "id": "settings.restore",
            "role": "owner",
            "protection": "S",
            "confirm": true,
            "label": {
                "de": "Einstellungen einspielen",
                "en": "Restore settings"
            },
            "notes": {
                "de": "Kein eigener Maschinenbefehl: die API spielt einen Sicherungsstand (settings snapshot) ein, Einstellungen und Schnellwahl mit normalen set-Befehlen (je Zustandsgruppe einer, höchstens 32 Werte), Bohnenprofile mit bean.restore, Pflege-Zähler mit care.restore; den Referenz-Bezug hält seit 19.10.2026 nur die Cloud. Schutzklasse S (E-11): nur der Besitzer, frische Anmeldung, je Wert der Schutzklasse S eine eigene Sicherheitsabfrage (FR-18). Für die Wiederherstellung nach Datenverlust (FR-52) und nach einer Neuinstallation (FR-47).",
                "en": "Not a machine command: the API restores a settings snapshot, settings and quick choice with normal set commands (one per state group, at most 32 values), bean profiles with bean.restore, care counters with care.restore; the reference shot is kept by the cloud only since 19.10.2026. Protection class S. For restoring after data loss (FR-52) and after a reinstallation (FR-47)."
            },
            "uses": [
                "set",
                "bean.restore",
                "care.restore"
            ]
        },
        {
            "id": "bean.select",
            "role": "member",
            "label": {
                "de": "Bohne wählen",
                "en": "Choose beans"
            },
            "notes": {
                "de": "Kein eigener Maschinenbefehl (Konzept beans-and-shot-history, Dominik 19.10.2026): die Cloud ist Quelle der Wahrheit für alle Bohnen und Rezepte, die Maschine hält nur das aktuelle. Die API schickt genau das Rezept der gewählten Bohne mit bean.put (ID der Cloud, neueste Rezeptversion, Röstdatum der aktiven Packung); bean.put erst, wenn jede Bohne der letzten state/beans-Meldung in der Bibliothek liegt.",
                "en": "Not a machine command: the cloud owns every bean and recipe, the machine holds only the current one. The API sends exactly the chosen bean's recipe with bean.put (cloud ID, newest recipe version, roast date of the active bag), and only once every bean of the last state/beans is in the library."
            },
            "uses": [
                "bean.put"
            ]
        }
    ],
    "commands": [
        {
            "id": "pid.enabled",
            "kind": "set",
            "category": "c",
            "group": "machine",
            "label": {
                "de": "Heizen",
                "en": "Heating"
            },
            "notes": {
                "de": "Schaltet die Regelung und damit die Heizung ein oder aus (M6).",
                "en": "Switches the controller and with it the heater on or off."
            },
            "role": "member",
            "actionClass": "setting",
            "escalate": {
                "when": {
                    "equals": true
                },
                "actionClass": "water_heat_wake"
            },
            "type": "bool",
            "default": false,
            "reboot": false
        },
        {
            "id": "pid.use_ponm",
            "kind": "set",
            "category": "c",
            "group": "machine",
            "label": {
                "de": "PonM",
                "en": "PonM"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "bool",
            "default": false,
            "reboot": false
        },
        {
            "id": "pid.ema_factor",
            "kind": "set",
            "category": "c",
            "group": "machine",
            "label": {
                "de": "EMA-Glättung",
                "en": "EMA smoothing"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 0,
            "max": 1,
            "step": 0.05,
            "default": 0.6,
            "reboot": false
        },
        {
            "id": "pid.regular.kp",
            "kind": "set",
            "category": "c",
            "group": "machine",
            "label": {
                "de": "PID Kp",
                "en": "PID Kp"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 0,
            "max": 999,
            "step": 1,
            "default": 62,
            "reboot": false
        },
        {
            "id": "pid.regular.tn",
            "kind": "set",
            "category": "c",
            "group": "machine",
            "label": {
                "de": "PID Tn",
                "en": "PID Tn"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 0,
            "max": 999,
            "step": 1,
            "unit": "s",
            "default": 52,
            "reboot": false
        },
        {
            "id": "pid.regular.tv",
            "kind": "set",
            "category": "c",
            "group": "machine",
            "label": {
                "de": "PID Tv",
                "en": "PID Tv"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 0,
            "max": 999,
            "step": 0.5,
            "unit": "s",
            "default": 11.5,
            "reboot": false
        },
        {
            "id": "pid.regular.i_max",
            "kind": "set",
            "category": "c",
            "group": "machine",
            "label": {
                "de": "PID I-Max",
                "en": "PID I max"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 0,
            "max": 999,
            "step": 1,
            "default": 55,
            "reboot": false
        },
        {
            "id": "brew.setpoint",
            "kind": "set",
            "category": "b",
            "group": "recipe",
            "label": {
                "de": "Brühtemperatur",
                "en": "Brew temperature"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 20,
            "max": 110,
            "step": 0.5,
            "unit": "°C",
            "default": 95,
            "reboot": false
        },
        {
            "id": "brew.temp_offset",
            "kind": "set",
            "category": "c",
            "group": "machine",
            "label": {
                "de": "Offset",
                "en": "Offset"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 0,
            "max": 20,
            "step": 0.1,
            "unit": "°C",
            "default": 0,
            "reboot": false
        },
        {
            "id": "brew.mode",
            "kind": "set",
            "category": "b",
            "group": "recipe",
            "label": {
                "de": "Bezugsart",
                "en": "Brew mode"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "enum",
            "options": [
                {
                    "value": 0,
                    "label": {
                        "de": "Von Hand",
                        "en": "Manual"
                    }
                },
                {
                    "value": 1,
                    "label": {
                        "de": "Automatisch",
                        "en": "Automatic"
                    }
                }
            ],
            "min": 0,
            "max": 1,
            "default": 0,
            "reboot": false
        },
        {
            "id": "brew.by_time.enabled",
            "kind": "set",
            "category": "b",
            "group": "recipe",
            "label": {
                "de": "Nach Zeit stoppen",
                "en": "Stop by time"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "bool",
            "default": false,
            "reboot": false,
            "visibleIf": "brew.mode == 1"
        },
        {
            "id": "brew.by_time.target_time",
            "kind": "set",
            "category": "b",
            "group": "recipe",
            "label": {
                "de": "Bezugszeit",
                "en": "Brew time"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 1,
            "max": 120,
            "step": 0.5,
            "unit": "s",
            "default": 25,
            "reboot": false,
            "visibleIf": "brew.mode == 1"
        },
        {
            "id": "brew.by_weight.enabled",
            "kind": "set",
            "category": "b",
            "group": "recipe",
            "label": {
                "de": "Nach Gewicht stoppen",
                "en": "Stop by weight"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "bool",
            "default": false,
            "reboot": false,
            "visibleIf": "brew.mode == 1",
            "requires": [
                "scale"
            ]
        },
        {
            "id": "brew.by_weight.target_weight",
            "kind": "set",
            "category": "b",
            "group": "recipe",
            "label": {
                "de": "Zielgewicht",
                "en": "Target weight"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 0,
            "max": 500,
            "step": 0.5,
            "unit": "g",
            "default": 36,
            "reboot": false,
            "visibleIf": "brew.mode == 1",
            "requires": [
                "scale"
            ]
        },
        {
            "id": "brew.by_weight.auto_tare",
            "kind": "set",
            "category": "b",
            "group": "recipe",
            "label": {
                "de": "Automatisch tarieren",
                "en": "Tare automatically"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "bool",
            "default": false,
            "reboot": false,
            "visibleIf": "brew.mode == 1",
            "requires": [
                "scale"
            ]
        },
        {
            "id": "brew.presets",
            "kind": "set",
            "category": "b",
            "group": "presets",
            "label": {
                "de": "Schnellwahl",
                "en": "Quick choice"
            },
            "notes": {
                "de": "Drei Rezepte „name|bohne|dosis|mahlgrad|temp|s|r|pi“, mit „;“ getrennt; leer bzw. 0 (pi: leer) lässt den Wert unverändert; r = Verhältnis Dosis:Tasse (README).",
                "en": "Three recipes 'name|bean|dose|grind|temp|s|r|pi' separated by ';'; empty or 0 (pi: empty) leaves the value as it is; r = ratio dose:cup."
            },
            "role": "member",
            "actionClass": "setting",
            "type": "string",
            "maxLength": 320,
            "format": "presets",
            "default": "25,2;30,2.5;45,4.5",
            "reboot": false
        },
        {
            "id": "brew.by_weight.lag",
            "kind": "set",
            "category": "b",
            "group": "recipe",
            "label": {
                "de": "Nachlaufzeit",
                "en": "Drop time"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 0,
            "max": 3,
            "step": 0.05,
            "unit": "s",
            "default": 1,
            "reboot": false
        },
        {
            "id": "brew.by_weight.learn",
            "kind": "set",
            "category": "b",
            "group": "recipe",
            "label": {
                "de": "Stopp automatisch lernen",
                "en": "Learn the stop"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "bool",
            "default": true,
            "reboot": false
        },
        {
            "id": "brew.heat_boost",
            "kind": "set",
            "category": "c",
            "group": "machine",
            "label": {
                "de": "Heizen beim Bezug",
                "en": "Heating during a shot"
            },
            "notes": {
                "de": "Schutzklasse S (E-11): Mindestleistung der Heizung während des Bezugs.",
                "en": "Protection class S (E-11): heater floor during a shot."
            },
            "role": "owner",
            "actionClass": "setting",
            "protection": "S",
            "confirm": true,
            "type": "number",
            "min": 0,
            "max": 100,
            "step": 5,
            "unit": "%",
            "default": 60,
            "reboot": false
        },
        {
            "id": "brew.dose",
            "kind": "set",
            "category": "b",
            "group": "recipe",
            "label": {
                "de": "Dosis",
                "en": "Dose"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 5,
            "max": 30,
            "step": 0.1,
            "unit": "g",
            "default": 18,
            "reboot": false
        },
        {
            "id": "brew.grind",
            "kind": "set",
            "category": "b",
            "group": "recipe",
            "label": {
                "de": "Mahlgrad",
                "en": "Grind"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "string",
            "maxLength": 9,
            "allowEmpty": true,
            "format": "text",
            "default": "",
            "reboot": false
        },
        {
            "id": "brew.grinder",
            "kind": "set",
            "category": "b",
            "group": "recipe",
            "label": {
                "de": "Mühle",
                "en": "Grinder"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "string",
            "maxLength": 40,
            "allowEmpty": true,
            "format": "text",
            "default": "",
            "reboot": false
        },
        {
            "id": "brew.beans",
            "kind": "set",
            "category": "b",
            "group": "recipe",
            "label": {
                "de": "Bohne",
                "en": "Beans"
            },
            "notes": {
                "de": "Wählt die Bohne über ihren Namen und lädt ihr Rezept; ein neuer Name legt eine neue Bohne an (B5, B16).",
                "en": "Selects the bean by name and loads its recipe; a new name creates a new bean."
            },
            "role": "member",
            "actionClass": "setting",
            "type": "string",
            "maxLength": 40,
            "allowEmpty": true,
            "format": "text",
            "default": "",
            "reboot": false
        },
        {
            "id": "brew.grind_scale",
            "kind": "set",
            "category": "b",
            "group": "recipe",
            "label": {
                "de": "Skala der Mühle",
                "en": "Grinder scale"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "enum",
            "options": [
                {
                    "value": 0,
                    "label": {
                        "de": "unbekannt",
                        "en": "Not known"
                    }
                },
                {
                    "value": 1,
                    "label": {
                        "de": "höher = feiner",
                        "en": "Higher is finer"
                    }
                },
                {
                    "value": 2,
                    "label": {
                        "de": "höher = gröber",
                        "en": "Higher is coarser"
                    }
                }
            ],
            "min": 0,
            "max": 2,
            "default": 0,
            "reboot": false
        },
        {
            "id": "backflush.remind_after",
            "kind": "set",
            "category": "c",
            "group": "maintenance",
            "label": {
                "de": "Backflush erinnern nach (Bezüge)",
                "en": "Remind of a backflush after (shots)"
            },
            "notes": {
                "de": "0 = nie",
                "en": "0 = never"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "integer",
            "min": 0,
            "max": 500,
            "step": 5,
            "default": 50,
            "reboot": false
        },
        {
            "id": "brew.warmup_flush",
            "kind": "set",
            "category": "d",
            "group": "schedule",
            "label": {
                "de": "Aufwärm-Spülen nach dem Kaltstart",
                "en": "Warm-up flush after a cold start"
            },
            "notes": {
                "de": "Schutzklasse S (E-11): pumpt ohne Person an der Maschine; nur mit Wasserstandssensor.",
                "en": "Protection class S (E-11): pumps without anybody at the machine; only with a water level sensor."
            },
            "role": "owner",
            "actionClass": "setting",
            "escalate": {
                "when": {
                    "equals": true
                },
                "actionClass": "water_heat_wake"
            },
            "protection": "S",
            "confirm": true,
            "type": "bool",
            "default": true,
            "reboot": false
        },
        {
            "id": "brew.warmup_flush_wait",
            "kind": "set",
            "category": "d",
            "group": "schedule",
            "label": {
                "de": "Wartezeit am Soll vor dem Aufwärm-Spülen",
                "en": "Wait at the setpoint before the warm-up flush"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 0,
            "max": 30,
            "step": 1,
            "unit": "min",
            "default": 2,
            "reboot": false
        },
        {
            "id": "schedule.enabled",
            "kind": "set",
            "category": "d",
            "group": "schedule",
            "label": {
                "de": "Automatisch einschalten",
                "en": "Switch on automatically"
            },
            "role": "member",
            "actionClass": "setting",
            "escalate": {
                "when": {
                    "equals": true
                },
                "actionClass": "water_heat_wake"
            },
            "type": "bool",
            "default": false,
            "reboot": false
        },
        {
            "id": "schedule.plan",
            "kind": "set",
            "category": "d",
            "group": "schedule",
            "label": {
                "de": "Wochenplan",
                "en": "Weekly plan"
            },
            "notes": {
                "de": "Mo…So mit „;“ getrennt, je Tag bis 2 Fenster „HH:MM-HH:MM“ (Aus optional) mit „,“; „?“ = noch nicht gesetzt.",
                "en": "Monday to Sunday separated by ';', up to 2 windows 'HH:MM-HH:MM' (off optional) per day separated by ','; '?' = not set yet."
            },
            "role": "member",
            "actionClass": "setting",
            "type": "string",
            "maxLength": 176,
            "format": "weekplan",
            "default": "?",
            "reboot": false
        },
        {
            "id": "schedule.pause_until",
            "kind": "set",
            "category": "d",
            "group": "schedule",
            "label": {
                "de": "Urlaub bis einschließlich",
                "en": "Holiday through"
            },
            "notes": {
                "de": "Lokaler Tag (Tage seit 1970-01-01), 0 = kein Urlaub.",
                "en": "Local day (days since 1970-01-01), 0 = no holiday."
            },
            "role": "member",
            "actionClass": "setting",
            "type": "integer",
            "min": 0,
            "max": 100000,
            "format": "localday",
            "default": 0,
            "reboot": false
        },
        {
            "id": "descale.litres",
            "kind": "set",
            "category": "c",
            "group": "maintenance",
            "label": {
                "de": "Entkalken erinnern bei",
                "en": "Remind of descaling at"
            },
            "notes": {
                "de": "0 = nie",
                "en": "0 = never"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 0,
            "max": 300,
            "step": 5,
            "unit": "l",
            "default": 40,
            "reboot": false
        },
        {
            "id": "drip.capacity",
            "kind": "set",
            "category": "c",
            "group": "maintenance",
            "label": {
                "de": "Tropfschale fasst",
                "en": "Drip tray holds"
            },
            "notes": {
                "de": "Schutzklasse S (E-11): 0 schaltet die Zählung aus, und damit fallen Bezug aus der App und Aufwärm-Spülen nach dem Wecken weg.",
                "en": "Protection class S (E-11): 0 switches counting off, which disables shots from the app and the warm-up flush after a wake-up."
            },
            "role": "owner",
            "actionClass": "setting",
            "protection": "S",
            "confirm": true,
            "type": "number",
            "min": 0,
            "max": 2000,
            "step": 50,
            "unit": "ml",
            "default": 600,
            "reboot": false
        },
        {
            "id": "brew.temp_end",
            "kind": "set",
            "category": "b",
            "group": "recipe",
            "label": {
                "de": "Verlauf im Bezug",
                "en": "Course during the shot"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": -5,
            "max": 5,
            "step": 0.5,
            "unit": "K",
            "default": 0,
            "reboot": false
        },
        {
            "id": "standby.warm_temp",
            "kind": "set",
            "category": "d",
            "group": "schedule",
            "label": {
                "de": "Im Standby warm halten",
                "en": "Keep warm in standby"
            },
            "notes": {
                "de": "0 = aus",
                "en": "0 = off"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 0,
            "max": 90,
            "step": 5,
            "unit": "°C",
            "default": 70,
            "reboot": false
        },
        {
            "id": "standby.warm_hours",
            "kind": "set",
            "category": "d",
            "group": "schedule",
            "label": {
                "de": "Danach ganz aus nach",
                "en": "Then off after"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 0.5,
            "max": 12,
            "step": 0.5,
            "unit": "h",
            "default": 2,
            "reboot": false
        },
        {
            "id": "standby.display_off",
            "kind": "set",
            "category": "c",
            "group": "machine",
            "label": {
                "de": "Uhr im Standby",
                "en": "Clock in standby"
            },
            "notes": {
                "de": "0 = immer an",
                "en": "0 = always on"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "integer",
            "min": 0,
            "max": 240,
            "step": 5,
            "unit": "min",
            "default": 0,
            "reboot": false
        },
        {
            "id": "brew.pre_infusion.enabled",
            "kind": "set",
            "category": "b",
            "group": "recipe",
            "label": {
                "de": "Pre-Infusion",
                "en": "Pre-infusion"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "bool",
            "default": false,
            "reboot": false
        },
        {
            "id": "brew.pre_infusion.time",
            "kind": "set",
            "category": "b",
            "group": "recipe",
            "label": {
                "de": "Pumpstoß",
                "en": "Burst"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 0,
            "max": 10,
            "step": 0.5,
            "unit": "s",
            "default": 2,
            "reboot": false
        },
        {
            "id": "brew.pre_infusion.pause",
            "kind": "set",
            "category": "b",
            "group": "recipe",
            "label": {
                "de": "Pause",
                "en": "Pause"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 0,
            "max": 15,
            "step": 0.5,
            "unit": "s",
            "default": 4,
            "reboot": false
        },
        {
            "id": "backflush.cycles",
            "kind": "set",
            "category": "d",
            "group": "maintenance",
            "label": {
                "de": "Backflush-Zyklen",
                "en": "Backflush cycles"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "integer",
            "min": 2,
            "max": 20,
            "step": 1,
            "default": 5,
            "reboot": false
        },
        {
            "id": "backflush.fill_time",
            "kind": "set",
            "category": "d",
            "group": "maintenance",
            "label": {
                "de": "Backflush pumpen",
                "en": "Backflush pump"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 3,
            "max": 10,
            "step": 0.5,
            "unit": "s",
            "default": 5,
            "reboot": false
        },
        {
            "id": "backflush.flush_time",
            "kind": "set",
            "category": "d",
            "group": "maintenance",
            "label": {
                "de": "Backflush Pause",
                "en": "Backflush pause"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 5,
            "max": 20,
            "step": 0.5,
            "unit": "s",
            "default": 10,
            "reboot": false
        },
        {
            "id": "standby.enabled",
            "kind": "set",
            "category": "d",
            "group": "schedule",
            "label": {
                "de": "Standby",
                "en": "Standby"
            },
            "notes": {
                "de": "Schutzklasse S (E-11): Auto-Standby aus heißt Heizen ohne Ende.",
                "en": "Protection class S (E-11): auto standby off means heating without end."
            },
            "role": "owner",
            "actionClass": "setting",
            "escalate": {
                "when": {
                    "equals": false
                },
                "actionClass": "water_heat_wake"
            },
            "protection": "S",
            "confirm": true,
            "type": "bool",
            "default": true,
            "reboot": false
        },
        {
            "id": "standby.time",
            "kind": "set",
            "category": "d",
            "group": "schedule",
            "label": {
                "de": "Standby nach",
                "en": "Standby after"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 1,
            "max": 120,
            "step": 5,
            "unit": "min",
            "default": 35,
            "reboot": false
        },
        {
            "id": "display.language",
            "kind": "set",
            "category": "c",
            "group": "machine",
            "label": {
                "de": "Sprache des Displays",
                "en": "Display language"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "enum",
            "options": [
                {
                    "value": 0,
                    "label": {
                        "de": "Deutsch",
                        "en": "German"
                    }
                },
                {
                    "value": 1,
                    "label": {
                        "de": "Englisch",
                        "en": "English"
                    }
                },
                {
                    "value": 2,
                    "label": {
                        "de": "Spanisch",
                        "en": "Spanish"
                    }
                }
            ],
            "min": 0,
            "max": 2,
            "default": 1,
            "reboot": false
        },
        {
            "id": "display.blescale_brew_timer",
            "kind": "set",
            "category": "c",
            "group": "machine",
            "label": {
                "de": "Timer der Waage mitlaufen lassen",
                "en": "Run the scale's timer"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "bool",
            "default": false,
            "reboot": false
        },
        {
            "id": "display.post_brew_timer_duration",
            "kind": "set",
            "category": "c",
            "group": "machine",
            "label": {
                "de": "FERTIG danach noch",
                "en": "Keep DONE for"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 0,
            "max": 60,
            "step": 0.5,
            "unit": "s",
            "default": 10,
            "reboot": false
        },
        {
            "id": "display.blinking.delta",
            "kind": "set",
            "category": "c",
            "group": "machine",
            "label": {
                "de": "Bereit ab",
                "en": "Ready within"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "number",
            "min": 0.2,
            "max": 10,
            "step": 0.1,
            "unit": "°C",
            "default": 0.3,
            "reboot": false
        },
        {
            "id": "system.hostname",
            "kind": "set",
            "category": "e",
            "group": "system",
            "label": {
                "de": "Gerätename",
                "en": "Device name"
            },
            "notes": {
                "de": "Technischer Name im WLAN; der Maschinenname der Cloud ist davon getrennt (FR-11).",
                "en": "Technical name in the WLAN; the cloud's machine name is separate (FR-11)."
            },
            "role": "member",
            "actionClass": "setting",
            "type": "string",
            "maxLength": 64,
            "format": "hostname",
            "default": "orione",
            "reboot": true
        },
        {
            "id": "system.log_level",
            "kind": "set",
            "category": "e",
            "group": "system",
            "label": {
                "de": "Protokoll-Level",
                "en": "Log level"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "enum",
            "options": [
                {
                    "value": 0,
                    "label": {
                        "de": "TRACE",
                        "en": "TRACE"
                    }
                },
                {
                    "value": 1,
                    "label": {
                        "de": "DEBUG",
                        "en": "DEBUG"
                    }
                },
                {
                    "value": 2,
                    "label": {
                        "de": "INFO",
                        "en": "INFO"
                    }
                },
                {
                    "value": 3,
                    "label": {
                        "de": "WARNING",
                        "en": "WARNING"
                    }
                },
                {
                    "value": 4,
                    "label": {
                        "de": "ERROR",
                        "en": "ERROR"
                    }
                },
                {
                    "value": 5,
                    "label": {
                        "de": "FATAL",
                        "en": "FATAL"
                    }
                }
            ],
            "min": 0,
            "max": 5,
            "default": 2,
            "reboot": false
        },
        {
            "id": "hardware.sensors.watertank.enabled",
            "kind": "set",
            "category": "c",
            "group": "machine",
            "label": {
                "de": "Füllstandssensor",
                "en": "Level sensor"
            },
            "notes": {
                "de": "Schutzklasse S (E-11): Voraussetzung für alle Wasseraktionen aus der Ferne.",
                "en": "Protection class S (E-11): required for every remote water action."
            },
            "role": "owner",
            "actionClass": "setting",
            "protection": "S",
            "confirm": true,
            "type": "bool",
            "default": false,
            "reboot": true
        },
        {
            "id": "hardware.sensors.watertank.mode",
            "kind": "set",
            "category": "c",
            "group": "machine",
            "label": {
                "de": "Schaltart des Füllstandssensors",
                "en": "Level sensor switch type"
            },
            "notes": {
                "de": "Schutzklasse S (E-11): eine falsche Schaltart meldet einen leeren Tank als voll.",
                "en": "Protection class S (E-11): a wrong switch type reports an empty tank as full."
            },
            "role": "owner",
            "actionClass": "setting",
            "protection": "S",
            "confirm": true,
            "type": "enum",
            "options": [
                {
                    "value": 0,
                    "label": {
                        "de": "Schließer",
                        "en": "Normally open"
                    }
                },
                {
                    "value": 1,
                    "label": {
                        "de": "Öffner",
                        "en": "Normally closed"
                    }
                }
            ],
            "min": 0,
            "max": 1,
            "default": 1,
            "reboot": true
        },
        {
            "id": "hardware.sensors.scale.enabled",
            "kind": "set",
            "category": "c",
            "group": "machine",
            "label": {
                "de": "Bluetooth-Waage",
                "en": "Bluetooth scale"
            },
            "role": "member",
            "actionClass": "setting",
            "type": "bool",
            "default": false,
            "reboot": true
        },
        {
            "id": "standby.set",
            "kind": "action",
            "category": "d",
            "label": {
                "de": "Standby / Aufwecken",
                "en": "Standby / wake up"
            },
            "notes": {
                "de": "Zielzustand: on=true braucht standby_allowed, on=false braucht in_standby; ist der Zielzustand schon erreicht, kommt done. Fern-Wecken wie Zeitplan (FR-45).",
                "en": "Target state: on=true needs standby_allowed, on=false needs in_standby; already there gives done. Remote wake-up behaves like the schedule."
            },
            "role": "member",
            "actionClass": "setting",
            "escalate": {
                "when": {
                    "arg": "on",
                    "equals": false
                },
                "actionClass": "water_heat_wake"
            },
            "args": {
                "type": "object",
                "required": [
                    "on"
                ],
                "properties": {
                    "on": {
                        "type": "boolean",
                        "description": "true = Standby, false = wecken"
                    }
                },
                "additionalProperties": false
            },
            "pre": [
                "standby_allowed",
                "in_standby"
            ],
            "answer": "done"
        },
        {
            "id": "flush.start",
            "kind": "action",
            "category": "d",
            "label": {
                "de": "Spülen",
                "en": "Flush"
            },
            "notes": {
                "de": "Display kündigt an; S3 bricht ab (FR-23).",
                "en": "The display announces it; S3 aborts."
            },
            "role": "member",
            "actionClass": "water_heat_wake",
            "confirm": true,
            "args": {
                "type": "object",
                "properties": {
                    "pulses": {
                        "type": "integer",
                        "minimum": 1,
                        "maximum": 3,
                        "default": 3,
                        "description": "3 = Aufwärm-Spülen, 1 = ein Spülstoß nach dem Bezug"
                    }
                },
                "additionalProperties": false
            },
            "announce": true,
            "limit": "water_remote",
            "pre": [
                "no_fault",
                "watertank_sensor",
                "tank_ok",
                "ready",
                "switch_off",
                "not_busy"
            ],
            "requires": [
                "watertank"
            ],
            "answer": "accepted_done"
        },
        {
            "id": "flush.stop",
            "kind": "action",
            "category": "d",
            "label": {
                "de": "Spülen abbrechen",
                "en": "Stop flushing"
            },
            "notes": {
                "de": "Immer erlaubt; läuft nichts, kommt done.",
                "en": "Always allowed; nothing running gives done."
            },
            "role": "member",
            "actionClass": "stop",
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "pre": [],
            "answer": "done"
        },
        {
            "id": "backflush.set",
            "kind": "action",
            "category": "d",
            "label": {
                "de": "Backflush-Modus",
                "en": "Backflush mode"
            },
            "notes": {
                "de": "Zielzustand statt Umschalter. Scharf geschaltet steht der Modus mit „by“ auf dem Display und verfällt nach 10 min ohne Start; den Ablauf startet S3 (FR-23). Die Grenze zählt nur armed=true.",
                "en": "Target state instead of a toggle. Armed, the display shows it with 'by'; it disarms after 10 min without a start; S3 starts the programme. The limit counts armed=true only."
            },
            "role": "member",
            "actionClass": "stop",
            "escalate": {
                "when": {
                    "arg": "armed",
                    "equals": true
                },
                "actionClass": "water_heat_wake"
            },
            "confirm": true,
            "args": {
                "type": "object",
                "required": [
                    "armed"
                ],
                "properties": {
                    "armed": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "limit": "water_remote",
            "pre": [
                "no_fault",
                "ready",
                "not_busy"
            ],
            "answer": "done"
        },
        {
            "id": "cleaning.set",
            "kind": "action",
            "category": "d",
            "label": {
                "de": "Reinigung mit Reiniger",
                "en": "Cleaning with detergent"
            },
            "notes": {
                "de": "Wie backflush.set, aber mit dem Reinigungsprogramm (Reiniger-Zyklen, ausspülen, klarspülen; jeweils mit S3).",
                "en": "Like backflush.set with the cleaning programme (detergent cycles, rinse out, clear rinse; each with S3)."
            },
            "role": "member",
            "actionClass": "stop",
            "escalate": {
                "when": {
                    "arg": "armed",
                    "equals": true
                },
                "actionClass": "water_heat_wake"
            },
            "confirm": true,
            "args": {
                "type": "object",
                "required": [
                    "armed"
                ],
                "properties": {
                    "armed": {
                        "type": "boolean"
                    }
                },
                "additionalProperties": false
            },
            "limit": "water_remote",
            "pre": [
                "no_fault",
                "ready",
                "not_busy"
            ],
            "answer": "done"
        },
        {
            "id": "descale.start",
            "kind": "action",
            "category": "d",
            "label": {
                "de": "Entkalk-Programm starten",
                "en": "Start descaling programme"
            },
            "notes": {
                "de": "Etwa 1 h: Heizung aus, wartet bis < 60 °C, 8 Runden, Rest, 2× Klarwasser; accepted beim Start, done am Ende oder beim Abbruch.",
                "en": "About 1 h: heater off, waits below 60 °C, 8 rounds, rest, 2x clear water; accepted at the start, done at the end or on abort."
            },
            "role": "member",
            "actionClass": "water_heat_wake",
            "confirm": true,
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "announce": true,
            "limit": "water_remote",
            "pre": [
                "no_fault",
                "watertank_sensor",
                "tank_ok",
                "switch_off",
                "not_busy"
            ],
            "requires": [
                "watertank"
            ],
            "answer": "accepted_done"
        },
        {
            "id": "descale.next",
            "kind": "action",
            "category": "d",
            "label": {
                "de": "Entkalken: Weiter",
                "en": "Descaling: next"
            },
            "notes": {
                "de": "Nur in Phase 3 (nachfüllen) oder 5 (Klarwasser einfüllen); expect nennt die Phase, sonst stale.",
                "en": "Only in phase 3 (refill) or 5 (fill clear water); expect names the phase, otherwise stale."
            },
            "role": "member",
            "actionClass": "water_heat_wake",
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "expect": [
                "descale.phase"
            ],
            "pre": [
                "tank_ok"
            ],
            "answer": "done"
        },
        {
            "id": "descale.stop",
            "kind": "action",
            "category": "d",
            "label": {
                "de": "Entkalken abbrechen",
                "en": "Abort descaling"
            },
            "role": "member",
            "actionClass": "stop",
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "pre": [],
            "answer": "done"
        },
        {
            "id": "scale.tare",
            "kind": "action",
            "category": "d",
            "label": {
                "de": "Waage tarieren",
                "en": "Tare the scale"
            },
            "notes": {
                "de": "Tara ist während eines Bezugs gesperrt (FR-18). Ein offenes Tara wird nicht ein zweites Mal ausgelöst.",
                "en": "Tare is blocked during a shot. An open tare is not triggered twice."
            },
            "role": "member",
            "actionClass": "setting",
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "pre": [
                "scale_enabled",
                "scale_connected",
                "not_brewing"
            ],
            "requires": [
                "scale"
            ],
            "answer": "done"
        },
        {
            "id": "drip.emptied",
            "kind": "action",
            "category": "d",
            "label": {
                "de": "Tropfschale geleert",
                "en": "Drip tray emptied"
            },
            "notes": {
                "de": "Setzt den Tropfschalen-Zähler auf 0; Ereignis care_reset.",
                "en": "Sets the drip tray counter to 0; event care_reset."
            },
            "role": "member",
            "actionClass": "setting",
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "pre": [],
            "answer": "done"
        },
        {
            "id": "care.descaled",
            "kind": "action",
            "category": "d",
            "label": {
                "de": "Als entkalkt eintragen",
                "en": "Mark as descaled"
            },
            "notes": {
                "de": "Entkalk-Zähler auf 0, Datum = jetzt; Ereignis care_reset.",
                "en": "Descaling counter to 0, date = now; event care_reset."
            },
            "role": "member",
            "actionClass": "setting",
            "confirm": true,
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "pre": [],
            "answer": "done"
        },
        {
            "id": "care.restore",
            "kind": "action",
            "category": "d",
            "label": {
                "de": "Pflege-Zähler wiederherstellen",
                "en": "Restore care counters"
            },
            "notes": {
                "de": "FR-52/FR-47: setzt die Zähler aus dem letzten guten Stand (state/care); Bezüge heute/Woche beginnen neu. Teil der Cloud-Operation settings.restore.",
                "en": "Sets the counters from the last good state (state/care); shots today/week start anew. Part of the cloud operation settings.restore."
            },
            "role": "owner",
            "actionClass": "setting",
            "protection": "S",
            "confirm": true,
            "args": {
                "type": "object",
                "required": [
                    "total",
                    "coffeeGrams",
                    "waterMl",
                    "descaledAt",
                    "backflushAt",
                    "shotsSinceBackflush",
                    "dripMl"
                ],
                "properties": {
                    "total": {
                        "type": "integer",
                        "minimum": 0,
                        "maximum": 4294967295
                    },
                    "coffeeGrams": {
                        "type": "number",
                        "minimum": 0
                    },
                    "waterMl": {
                        "type": "integer",
                        "minimum": 0,
                        "maximum": 4294967295
                    },
                    "descaledAt": {
                        "anyOf": [
                            {
                                "type": "integer",
                                "minimum": 1577836800,
                                "maximum": 4294967295
                            },
                            {
                                "type": "null"
                            }
                        ]
                    },
                    "backflushAt": {
                        "anyOf": [
                            {
                                "type": "integer",
                                "minimum": 1577836800,
                                "maximum": 4294967295
                            },
                            {
                                "type": "null"
                            }
                        ]
                    },
                    "shotsSinceBackflush": {
                        "type": "integer",
                        "minimum": 0,
                        "maximum": 65535
                    },
                    "dripMl": {
                        "type": "integer",
                        "minimum": 0,
                        "maximum": 65535
                    }
                },
                "additionalProperties": false
            },
            "pre": [
                "not_busy"
            ],
            "answer": "done"
        },
        {
            "id": "brew.start",
            "kind": "action",
            "category": "d",
            "label": {
                "de": "Bezug starten",
                "en": "Start a shot"
            },
            "notes": {
                "de": "FR-25: Display kündigt etwa 3 s vorher an; jede Flanke von S3 stoppt, danach kein Spülfenster; feste Höchstdauer; accepted beim Start, done mit data.shot (Schlüssel) am Ende. Der Bezug kommt mit source app und cmd.",
                "en": "FR-25: the display announces it about 3 s before; every edge of S3 stops, no flush window afterwards; fixed longest duration; accepted at the start, done with data.shot (key) at the end."
            },
            "role": "member",
            "actionClass": "water_heat_wake",
            "confirm": true,
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "announce": true,
            "limit": "brew_app",
            "pre": [
                "no_fault",
                "ready",
                "switch_off",
                "watertank_sensor",
                "tank_ok",
                "drip_counted",
                "drip_not_full",
                "not_busy",
                "stop_auto"
            ],
            "requires": [
                "watertank"
            ],
            "answer": "accepted_done"
        },
        {
            "id": "brew.stop",
            "kind": "action",
            "category": "d",
            "label": {
                "de": "Bezug stoppen",
                "en": "Stop the shot"
            },
            "notes": {
                "de": "Immer erlaubt, stoppt jeden laufenden Bezug; läuft keiner, kommt done.",
                "en": "Always allowed, stops any running shot; none running gives done."
            },
            "role": "member",
            "actionClass": "stop",
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "pre": [],
            "answer": "done"
        },
        {
            "id": "scale.discover",
            "kind": "action",
            "category": "e",
            "label": {
                "de": "Waage suchen",
                "en": "Search for scales"
            },
            "notes": {
                "de": "Sucht etwa 12 s; das Ergebnis steht in state/scale found und in done data.found.",
                "en": "Searches about 12 s; the result is in state/scale found and in done data.found."
            },
            "role": "member",
            "actionClass": "setting",
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "pre": [
                "scale_enabled",
                "not_brewing"
            ],
            "requires": [
                "scale"
            ],
            "answer": "accepted_done"
        },
        {
            "id": "scale.select",
            "kind": "action",
            "category": "e",
            "label": {
                "de": "Waage verbinden",
                "en": "Connect scale"
            },
            "notes": {
                "de": "Merkt die Waage und verbindet nur diese (FR-15).",
                "en": "Remembers the scale and connects only to it."
            },
            "role": "member",
            "actionClass": "setting",
            "args": {
                "type": "object",
                "required": [
                    "address",
                    "name"
                ],
                "properties": {
                    "address": {
                        "type": "string",
                        "pattern": "^([0-9a-f]{2}:){5}[0-9a-f]{2}$"
                    },
                    "name": {
                        "type": "string",
                        "maxLength": 23
                    }
                },
                "additionalProperties": false
            },
            "pre": [
                "scale_enabled",
                "not_brewing"
            ],
            "requires": [
                "scale"
            ],
            "answer": "accepted_done"
        },
        {
            "id": "scale.forget",
            "kind": "action",
            "category": "e",
            "label": {
                "de": "Waage vergessen",
                "en": "Forget scale"
            },
            "role": "member",
            "actionClass": "setting",
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "pre": [
                "scale_enabled",
                "not_brewing"
            ],
            "requires": [
                "scale"
            ],
            "answer": "done"
        },
        {
            "id": "bean.rename",
            "kind": "action",
            "category": "b",
            "label": {
                "de": "Bohne umbenennen",
                "en": "Rename bean"
            },
            "notes": {
                "de": "Die ID bleibt; Werte, Röstdatum, Bezüge, Referenz und Schnellwahl ziehen mit (B17).",
                "en": "The ID stays; values, roast date, shots, reference and quick choice follow."
            },
            "role": "member",
            "actionClass": "setting",
            "args": {
                "type": "object",
                "required": [
                    "id",
                    "name"
                ],
                "properties": {
                    "id": {
                        "type": "integer",
                        "minimum": 0,
                        "maximum": 4294967295
                    },
                    "name": {
                        "type": "string",
                        "minLength": 1,
                        "maxLength": 40
                    }
                },
                "additionalProperties": false
            },
            "pre": [
                "record_on_machine",
                "not_brewing"
            ],
            "answer": "done"
        },
        {
            "id": "bean.delete",
            "kind": "action",
            "category": "b",
            "label": {
                "de": "Bohne löschen",
                "en": "Delete bean"
            },
            "role": "member",
            "actionClass": "setting",
            "confirm": true,
            "args": {
                "type": "object",
                "required": [
                    "id"
                ],
                "properties": {
                    "id": {
                        "type": "integer",
                        "minimum": 0,
                        "maximum": 4294967295
                    }
                },
                "additionalProperties": false
            },
            "pre": [
                "record_on_machine",
                "bean_not_current",
                "not_brewing"
            ],
            "answer": "done"
        },
        {
            "id": "bean.roast",
            "kind": "action",
            "category": "b",
            "label": {
                "de": "Röstdatum setzen",
                "en": "Set roast date"
            },
            "role": "member",
            "actionClass": "setting",
            "args": {
                "type": "object",
                "required": [
                    "id",
                    "day"
                ],
                "properties": {
                    "id": {
                        "type": "integer",
                        "minimum": 0,
                        "maximum": 4294967295
                    },
                    "day": {
                        "anyOf": [
                            {
                                "type": "integer",
                                "minimum": 0,
                                "maximum": 100000
                            },
                            {
                                "type": "null"
                            }
                        ],
                        "description": "lokaler Tag seit 1970-01-01, null = keins"
                    }
                },
                "additionalProperties": false
            },
            "pre": [
                "record_on_machine"
            ],
            "answer": "done"
        },
        {
            "id": "bean.restore",
            "kind": "action",
            "category": "b",
            "label": {
                "de": "Bohnenprofil wiederherstellen",
                "en": "Restore bean profile"
            },
            "notes": {
                "de": "FR-52/FR-47: legt das Profil mit seiner stabilen ID an oder überschreibt es (ganzes Rezept, Röstdatum). Die Cloud spielt mehrere Profile vom ältesten zum zuletzt benutzten ein, damit die Reihenfolge stimmt. Sind alle Plätze von anderen IDs belegt: storage_full. Teil der Cloud-Operation settings.restore.",
                "en": "Creates or overwrites the profile with its stable ID (whole recipe, roast date). The cloud restores several profiles from the oldest to the last used one so the order is right. All places taken by other IDs: storage_full. Part of the cloud operation settings.restore."
            },
            "role": "owner",
            "actionClass": "setting",
            "protection": "S",
            "confirm": true,
            "args": {
                "type": "object",
                "required": [
                    "bean"
                ],
                "properties": {
                    "bean": {
                        "$ref": "https://brewcore.invalid/protocol/v1/schema/state-beans.schema.json#/$defs/bean"
                    }
                },
                "additionalProperties": false
            },
            "pre": [
                "not_brewing",
                "heap_ok"
            ],
            "answer": "done"
        },
        {
            "id": "bean.put",
            "kind": "action",
            "category": "b",
            "label": {
                "de": "Bohne auf die Maschine bringen",
                "en": "Put beans on the machine"
            },
            "notes": {
                "de": "Die Maschine hält nur das aktuelle Rezept (Dominik, 19.10.2026: \"die maschine braucht nicht alle rezepte kennen\"): die Bohne wird mit ihrer ID die einzige und die aktuelle (Rezept angewandt, brew.beans gesetzt, binnen 500 ms), alle anderen Plätze werden geleert, auch bei voller Maschine. Kein storage_full, keine Rückfrage, nicht Schutzklasse S (Mitnutzer). Eine noch nicht übernommene vorige: pending. Teil der Cloud-Operation bean.select.",
                "en": "The machine holds only the current recipe: the bean with its ID becomes the only one and the current one (recipe applied, brew.beans set, within 500 ms); every other place is emptied, a full machine as well. No storage_full, no confirmation, not protection class S (members). One before not applied yet: pending. Part of the cloud operation bean.select."
            },
            "role": "member",
            "actionClass": "setting",
            "args": {
                "type": "object",
                "required": [
                    "bean"
                ],
                "properties": {
                    "bean": {
                        "$ref": "https://brewcore.invalid/protocol/v1/schema/state-beans.schema.json#/$defs/bean"
                    }
                },
                "additionalProperties": false
            },
            "pre": [
                "not_brewing",
                "heap_ok"
            ],
            "answer": "done"
        },
        {
            "id": "restart",
            "kind": "action",
            "category": "e",
            "label": {
                "de": "Neu starten",
                "en": "Restart"
            },
            "notes": {
                "de": "done vor der Ausführung, dann status offline why=restart; danach derselbe Betriebszustand wie vorher (FR-45).",
                "en": "done before it runs, then status offline why=restart; afterwards the same operating state as before."
            },
            "role": "member",
            "actionClass": "device_admin",
            "confirm": true,
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "limit": "restart",
            "pre": [
                "not_busy"
            ],
            "ackBeforeExecution": true,
            "answer": "done"
        },
        {
            "id": "wifi.reset",
            "kind": "action",
            "category": "e",
            "label": {
                "de": "WLAN zurücksetzen",
                "en": "Reset WLAN"
            },
            "notes": {
                "de": "Die Maschine ist danach offline, bis jemand an ihr das WLAN neu einrichtet (FR-24). Kopplung bleibt (FR-8).",
                "en": "The machine is offline until somebody sets up the WLAN at the machine. The coupling stays."
            },
            "role": "owner",
            "actionClass": "device_admin",
            "confirm": true,
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "limit": "wifi_reset",
            "pre": [
                "not_busy"
            ],
            "ackBeforeExecution": true,
            "answer": "done"
        },
        {
            "id": "factory.reset",
            "kind": "action",
            "category": "e",
            "label": {
                "de": "Werkseinstellungen",
                "en": "Factory reset"
            },
            "notes": {
                "de": "Danach ist die Maschine entkoppelt und offline, bis jemand an ihr neu koppelt; Bezüge, Bohnen und Zugangsdaten auf der Maschine sind gelöscht, der Verlauf in der Cloud bleibt (FR-24). Neue Datengenerationen mit origin reset.",
                "en": "Afterwards the machine is unpaired and offline until somebody pairs it at the machine; shots, beans and credentials on the machine are deleted, the cloud history stays. New data generations with origin reset."
            },
            "role": "owner",
            "actionClass": "device_admin",
            "confirm": true,
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "limit": "factory_reset",
            "pre": [
                "not_busy"
            ],
            "ackBeforeExecution": true,
            "answer": "done"
        },
        {
            "id": "unpair",
            "kind": "action",
            "category": "e",
            "label": {
                "de": "Entkoppeln",
                "en": "Unpair"
            },
            "notes": {
                "de": "FR-12: löscht Bezüge, Referenz, Bohnen, Schnellwahl und Zugangsdaten auf der Maschine, Pflege-Zähler bleiben; danach widerruft die Cloud den Zugang. Ist die Maschine offline, merkt sie es am Widerruf (reauth → revoked).",
                "en": "Deletes shots, reference, beans, quick choice and credentials on the machine, care counters stay; then the cloud revokes the account. Offline machines learn it from the revocation."
            },
            "role": "owner",
            "actionClass": "device_admin",
            "confirm": true,
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "pre": [
                "not_busy"
            ],
            "ackBeforeExecution": true,
            "answer": "done"
        },
        {
            "id": "update.start",
            "kind": "action",
            "category": "e",
            "label": {
                "de": "Firmware-Update starten",
                "en": "Start firmware update"
            },
            "notes": {
                "de": "accepted, dann Update-Modus nur aus Standby oder Leerlauf (Relais aus, Waage getrennt, Fortschritt am Display), Stücke per fw/req und fw/data; done nach Prüfung von Hash und Signatur unmittelbar vor dem Neustart. Die Cloud startet erst mit einer Sicherung jünger als 5 min (AE-34).",
                "en": "accepted, then update mode only from standby or idle, pieces via fw/req and fw/data; done after checking hash and signature right before the restart."
            },
            "role": "owner",
            "actionClass": "device_admin",
            "args": {
                "type": "object",
                "required": [
                    "tag",
                    "manifest",
                    "sig",
                    "key",
                    "chunk"
                ],
                "properties": {
                    "tag": {
                        "type": "integer",
                        "minimum": 1,
                        "maximum": 4294967295,
                        "description": "Kennung dieses Update-Versuchs, steht in jedem fw/data-Rahmen"
                    },
                    "manifest": {
                        "type": "string",
                        "maxLength": 1024,
                        "pattern": "^[A-Za-z0-9_-]+$",
                        "description": "base64url der Manifest-Bytes (fw-manifest.schema.json)"
                    },
                    "sig": {
                        "type": "string",
                        "maxLength": 128,
                        "pattern": "^[A-Za-z0-9_-]+$",
                        "description": "base64url der ECDSA-P-256-Signatur (DER) über die Manifest-Bytes"
                    },
                    "key": {
                        "type": "integer",
                        "minimum": 0,
                        "maximum": 1,
                        "description": "welcher der zwei öffentlichen Schlüssel"
                    },
                    "chunk": {
                        "type": "integer",
                        "minimum": 256,
                        "maximum": 16384,
                        "description": "Stückgröße"
                    }
                },
                "additionalProperties": false
            },
            "limit": "update",
            "pre": [
                "idle_or_standby",
                "type_match",
                "heap_ok"
            ],
            "answer": "accepted_done"
        },
        {
            "id": "update.abort",
            "kind": "action",
            "category": "e",
            "label": {
                "de": "Firmware-Update abbrechen",
                "en": "Abort firmware update"
            },
            "role": "owner",
            "actionClass": "stop",
            "args": {
                "type": "object",
                "properties": {
                    "tag": {
                        "type": "integer",
                        "minimum": 1,
                        "maximum": 4294967295
                    }
                },
                "additionalProperties": false
            },
            "pre": [],
            "answer": "done"
        },
        {
            "id": "diag.log",
            "kind": "action",
            "category": "e",
            "label": {
                "de": "Protokoll holen",
                "en": "Fetch log"
            },
            "notes": {
                "de": "Letzte ~4 KB Log als xfer kind log (text).",
                "en": "Last ~4 KB of log as xfer kind log."
            },
            "role": "member",
            "actionClass": "diag",
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "pre": [
                "heap_ok"
            ],
            "answer": "xfer"
        },
        {
            "id": "diag.crash",
            "kind": "action",
            "category": "e",
            "label": {
                "de": "Absturzbericht holen",
                "en": "Fetch crash report"
            },
            "notes": {
                "de": "Letzter Absturz (übersteht Stromtrennung) als xfer kind crash; nach einem Absturz-Start schickt die Maschine ihn einmal von selbst.",
                "en": "Last crash as xfer kind crash; after a crash start the machine sends it once by itself."
            },
            "role": "member",
            "actionClass": "diag",
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "pre": [
                "heap_ok"
            ],
            "answer": "xfer"
        },
        {
            "id": "diag.heap",
            "kind": "action",
            "category": "e",
            "label": {
                "de": "Speicher je Startschritt",
                "en": "Heap per start stage"
            },
            "role": "member",
            "actionClass": "diag",
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "pre": [
                "heap_ok"
            ],
            "answer": "xfer"
        },
        {
            "id": "diag.boot",
            "kind": "action",
            "category": "e",
            "label": {
                "de": "Startdetails",
                "en": "Boot details"
            },
            "notes": {
                "de": "Wie GET /boot: Heap, Stack je Task, NVS belegt/frei, Firmware-Zustand, als xfer kind boot (json).",
                "en": "Like GET /boot, as xfer kind boot (json)."
            },
            "role": "member",
            "actionClass": "diag",
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "pre": [
                "heap_ok"
            ],
            "answer": "xfer"
        },
        {
            "id": "diag.measure",
            "kind": "action",
            "category": "e",
            "label": {
                "de": "Messzeilen holen",
                "en": "Fetch measurement lines"
            },
            "notes": {
                "de": "Die Messzeilen der Cloud-Verbindung (Präfix BC: Abbild und Slot, TLS-Block, jeder Handshake mit Heap vorher/währenddessen/nachher, Zähler, Heap, Stacks) als xfer kind diag (text). Die Maschine schickt sie außerdem von selbst alle 10 min und nach jedem Handshake (x = diag-<boot>-<n>, ohne Quittung auf sync). Für die Messungen M-08 bis M-12 und G-1b in der Maschine (Entscheidung 18.10.2026: kein Tisch-ESP32).",
                "en": "The cloud link's measurement lines (prefix BC: image and slot, TLS block, every handshake with heap before/during/after, counters, heap, stacks) as xfer kind diag (text). The machine also sends them by itself every 10 min and after every handshake (x = diag-<boot>-<n>, not acknowledged on sync). For measurements M-08 to M-12 and G-1b in the machine."
            },
            "role": "member",
            "actionClass": "diag",
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "pre": [
                "heap_ok"
            ],
            "answer": "xfer"
        },
        {
            "id": "catalog.get",
            "kind": "action",
            "category": "e",
            "label": {
                "de": "Befehlsliste holen",
                "en": "Fetch command catalog"
            },
            "notes": {
                "de": "Nur die API, bei unbekannter Prüfsumme (Entwicklungs-Builds, AE-10); xfer kind catalog (json).",
                "en": "Only the API, for an unknown checksum; xfer kind catalog."
            },
            "role": "system",
            "actionClass": "diag",
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "pre": [
                "heap_ok"
            ],
            "answer": "xfer"
        },
        {
            "id": "timeseries.get",
            "kind": "action",
            "category": "a",
            "label": {
                "de": "Temperaturverlauf holen",
                "en": "Fetch temperature history"
            },
            "notes": {
                "de": "Nur die API, beim ersten Zuschauer (FR-13); xfer kind timeseries (json, doc-timeseries).",
                "en": "Only the API, at the first viewer; xfer kind timeseries."
            },
            "role": "system",
            "actionClass": "diag",
            "args": {
                "type": "object",
                "additionalProperties": false
            },
            "pre": [
                "heap_ok"
            ],
            "answer": "xfer"
        }
    ]
};
//# sourceMappingURL=catalogs.js.map